import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/categorybutton.css';

interface CategoryButtonProps {
  activeTab: 'materials' | 'services';
  setActiveTab: (tab: 'materials' | 'services') => void;
}

const CategoryButton: React.FC<CategoryButtonProps> = () => {
  const navigate = useNavigate();



  return (
    <div className="category-navigation">
      <div className="tab-wrapper">
        {/* <div className="toggle-container">
          <button 
            className={`toggle-button ${activeTab === 'materials' ? 'active' : ''}`}
            onClick={() => setActiveTab('materials')}
          >
            Materials
          </button>
          <button 
            className={`toggle-button ${activeTab === 'services' ? 'active' : ''}`}
            onClick={() => setActiveTab('services')}
          >
            Services
          </button>
        </div> */}
      </div>
      <button className="view-all-button" onClick={() => navigate('/categories/view-all')}>
        View All
      </button>
    </div>
  );
};

export default CategoryButton;


